<template>
  <div class="input">
    <div class="input-label">住所</div>
    <div class="input-group">
      <textarea
        rows="3"
        class="input-textarea"
        v-model="address">
      </textarea>
    </div>
  </div>
</template>

<script>
export default {
  computed: {
    address: {
      get: function () {
        return this.$store.state.user.address
      },
      set: function (value) {
        this.$store.commit('user/setAddress', value)
      }
    }
  }
}
</script>


<style lang="scss" scoped>
@import '@/styles/_form.scss';
</style>
